import { Link } from 'react-router-dom';
import { PanelCard } from '../../../school_panel/components/ui';
import { useExamMarking } from '../../../school_panel/api/hooks';
import { plural } from '../../../school_panel/lib/plural';


/** Exam-detail card for worksheets and homework with written questions. */
export default function MarkingCard({ examId }: { examId: number }) {
  const { data } = useExamMarking(examId);
  if (!data || data.questions.length === 0) return null;
  const total = data.total_to_mark;
  const withToMark = data.questions.filter((q) => q.to_mark > 0).length;
  return (
    <PanelCard title="Marking" className="mb-[18px]" size="compact"
      subtitle="AI suggests a mark from the model answer; you confirm every mark.">
      {total > 0 ? (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm font-semibold text-ink">
            {`${plural(total, 'answer', 'answers')} to mark · ${plural(withToMark, 'question', 'questions')}`}
          </p>
          <Link to={`/worksheets/${examId}/marking`}
            className="inline-flex min-h-[44px] items-center justify-center rounded-[12px] border border-accent bg-accent px-4 py-2 text-sm font-semibold text-navy no-underline hover:text-navy hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent">
            Start marking
          </Link>
        </div>
      ) : (
        <div className="flex flex-wrap items-center justify-between gap-3">
          <p className="text-sm text-ink">All written answers marked</p>
          <Link to={`/worksheets/${examId}/marking`} className="text-sm font-semibold text-ink underline underline-offset-[3px] hover:text-muted-2">
            Review marks
          </Link>
        </div>
      )}
    </PanelCard>
  );
}
